/**
 * Component rows store TOTAL quantities (not per-unit — the per-unit ratio
 * is only derived at save time by dividing by the batch's own quantity).
 * When "כמות לייצור" changes AFTER components were already picked/loaded —
 * the common order: pick the product, see what it needs, THEN decide how
 * many to make — every row must rescale proportionally to keep its
 * per-unit ratio, or it stays stuck at whatever total matched the OLD
 * quantity (often 1, from the very first empty row).
 */
export function rescaleComponents(components, oldQty, newQty) {
  if (!Number.isFinite(oldQty) || oldQty <= 0 || !Number.isFinite(newQty) || newQty <= 0 || newQty === oldQty) {
    return components;
  }
  const ratio = newQty / oldQty;
  return components.map(c => ({ ...c, quantity: (Number(c.quantity) || 0) * ratio }));
}
